/* eslint-disable */
'use client';
declare var geq: any;
import { Cart } from '../../../interface/checkoutInterface';
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';

export class RetentionPixelTracker implements Tracker {
  private pixelIDs: string[];

  constructor(pixelIDs: string[]) {
    if (pixelIDs.length === 0) {
      console.error(
        '[RetentionPixelTracker] Constructor: No pixel IDs provided.',
      );
      throw new Error('RetentionPixelTracker requires at least one pixel ID.');
    }
    this.pixelIDs = pixelIDs;
    console.debug(
      '[RetentionPixelTracker] Constructor: Initialized with pixel IDs:',
      this.pixelIDs,
    );
  }

  Init(): void {
    console.debug(
      '[RetentionPixelTracker] Init: Starting pixel initialization.',
    );
    try {
      this.initializePixels();
    } catch (error) {
      console.error(
        '[RetentionPixelTracker] Init: Failed to initialize pixels:',
        error,
      );
    }
  }

  private initializePixels() {
    console.debug(
      '[RetentionPixelTracker] initializePixels: Injecting Retention Pixel script.',
    );

    try {
      (function (
        e: { [key: string]: any },
        n: Document,
        t: string,
        i: string,
        p?: any,
        a?: HTMLScriptElement,
        s?: Node,
      ) {
        if (!e[i]) {
          console.debug(
            '[RetentionPixelTracker] initializePixels: Creating geq object.',
          );
          p = function () {
            if (typeof p.process === 'function') {
              console.debug(
                '[RetentionPixelTracker] initializePixels: Processing queue function.',
              );
              p.process.apply(p, arguments);
            } else {
              console.debug(
                '[RetentionPixelTracker] initializePixels: Queueing arguments:',
                arguments,
              );
              p.queue.push(arguments);
            }
          };

          p.queue = [];
          p.t = +new Date();

          e[i] = p;

          a = n.createElement(t) as HTMLScriptElement;
          a.async = true;
          a.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/G5QHOXX9/ge.js';
          a.onload = function () {
            console.log(
              '[RetentionPixelTracker] initializePixels: Retention Pixel script loaded successfully.',
            );
          };
          a.onerror = function () {
            console.error(
              '[RetentionPixelTracker] initializePixels: Failed to load Retention Pixel script.',
            );
          };

          s = n.getElementsByTagName(t)[0];
          s.parentNode!.insertBefore(a, s);
        } else {
          console.debug(
            '[RetentionPixelTracker] initializePixels: geq object already exists.',
          );
        }
      })(window as any, document, 'script', 'geq');

      // Initialize pixel IDs
      this.pixelIDs.forEach(pixelID => {
        console.debug(
          `[RetentionPixelTracker] initializePixels: Initializing pixel ID: ${pixelID}`,
        );
        try {
          if (typeof geq.page === 'function') {
            geq.page();
            console.log(
              `[RetentionPixelTracker] initializePixels: Pixel ${pixelID} initialized successfully.`,
            );
          } else {
            console.warn(
              `[RetentionPixelTracker] initializePixels: geq.page is not a function for pixel ID: ${pixelID}.`,
            );
          }
        } catch (error) {
          console.error(
            `[RetentionPixelTracker] initializePixels: Error initializing pixel ID: ${pixelID}`,
            error,
          );
        }
      });
    } catch (error) {
      console.error(
        '[RetentionPixelTracker] initializePixels: Error during script injection:',
        error,
      );
    }
  }

  TrackEvent(event: RawEvent): void {
    console.debug('[RetentionPixelTracker] TrackEvent: Received event:', event);

    try {
      const mappedEventName = this.mapEventName(event.eventName);
      const cart: Cart | undefined = event?.cart;
      console.debug(
        `[RetentionPixelTracker] TrackEvent: Mapped event name: ${mappedEventName}`,
      );

      if (event.eventName === 'Purchase') {
        const eventData = {
          order_number: event?.orderId || 'UNKNOWN',
          order_amount: cart ? parseFloat(cart.TotalAmount) || 0 : 0,
          order_email: cart && cart.Email,
        };
        console.debug(
          '[RetentionPixelTracker] TrackEvent: Tracking purchase event data:',
          eventData,
        );

        this.pixelIDs.forEach(pixelID => {
          try {
            if (typeof geq.trackOrder === 'function') {
              geq.trackOrder(eventData);
              console.log(
                `[RetentionPixelTracker] TrackEvent: Tracked purchase event for pixel ID: ${pixelID}`,
              );
            } else {
              console.warn(
                `[RetentionPixelTracker] TrackEvent: geq.trackOrder is not a function for pixel ID: ${pixelID}.`,
              );
            }
          } catch (error) {
            console.error(
              `[RetentionPixelTracker] TrackEvent: Failed to track purchase for pixel ID: ${pixelID}`,
              error,
            );
          }
        });
      } else {
        console.debug(
          `[RetentionPixelTracker] TrackEvent: Event "${event.eventName}" is not tracked as a purchase.`,
        );
      }
    } catch (error) {
      console.error(
        '[RetentionPixelTracker] TrackEvent: Error tracking event:',
        error,
      );
    }
  }

  private mapEventName(eventName: string): string {
    console.debug(
      `[RetentionPixelTracker] mapEventName: Mapping event name: ${eventName}`,
    );
    try {
      switch (eventName) {
        case 'InitiateCheckout':
          return 'initiate_checkout';
        case 'Purchase':
          return 'complete_payment';
        default:
          return eventName;
      }
    } catch (error) {
      console.error(
        '[RetentionPixelTracker] mapEventName: Error mapping event name:',
        error,
      );
      return eventName; // Default to original name if mapping fails
    }
  }
}
